import React, { memo, useCallback, useState } from '../../../lib/teact/teact';


import type { FC } from '../../../lib/teact/teact';
import { SettingsScreens } from '../../../types';


import { LAYERS_ANIMATION_NAME } from '../../../util/windowEnvironment';


import useLastCallback from '../../../hooks/useLastCallback';



import LotMainHeader from '../header/LotMainHeader';


import { useEffect } from '../../../lib/teact/teact';

import store from '../store';

import Mainworking from '../working/mainworking';
import Lotcontactlist from '../contact/lotcontactlist';
import { LotScreenSettings } from '../config/uiconfig';

import EditContact from '../contact/editContact';
import Login from '../auth/login';
import { LoginApi } from '../restapi/loginApi';
import '../../left/LeftColumn.scss';
import './LotLeftColumn.scss'
//import './../../left/main/leftmain.scss'
import NhapTinNhan from '../message/nhapTinNhan';
import GlobalSetting from '../globalSettings/globalSetting';
import TotalReportByContact from '../reports/Report/totalReportByContact';
import DetailsReport from '../reports/Report/detailsReport';


import AdminScreen from '../admin/AdminScreen';
import { filterContact } from '../redux/contactsSlice';
import TronSo from '../working/tronSo';
import { getActions } from '../../../global';
import { functionQueue } from '../working/functionQueue';
import { parseMessageAuto } from '../working/CanChuyenLib';
import { DEBUG } from '../../../config';
import worker from '../setupWorker';
import Snackbar from '../ui/snackbar';
import BotConfig from '../bot/BotConfig';
import { isGuest } from '../utils/guest';
import Mainreport from '../reports/CongNo/mainreport';
import ConfirmDialog from '../../ui/ConfirmDialog';
import { daiLyChinh, nhomTelegram, setDaiLyChinh } from '../globalSettings/globalVariable';
import Ketquaxoso from '../ketquaxoso/ketquaxoso';
import useSelector from '../../../hooks/data/useSelector';
import { getWSClient } from '../websocket/nativeapp';
import { syncChats, syncTeleMessages } from '../db/gotd';
import { IChatSyncState } from '../db/model/chatSyncState';
import { updateAccessToken } from '../redux/loginSlice';
/*Màn hình đầu tiên của app*/

const TRANSITION_RENDER_COUNT = Object.keys(SettingsScreens).length / 2;
const TRANSITION_DURATION = 200;
type Contact = {
  name: string
  id: Number
}

export type OwnProps = {
  onReset: (forceReturnToChatList?: true | Event) => void;

  shouldSkipTransition?: boolean;

};

const LotLeftColumn: FC<OwnProps> = ({
  onReset,
  shouldSkipTransition,

}) => {
  let {
    sendMessage,
  } = getActions();
  const [state, setState] = useState({
    snackbarText: "",
    showSnackbar: false,
    options: undefined as any, // snackbar options
    showMessageDialog: false,
    messageToShow: "",
    daiLyChinh: daiLyChinh,
  })
  const [currentScreen, setCurrentScreen] = useState(
    isGuest() ? LotScreenSettings.TOTAL_REPORT_BY_CONTACT_SCREEN : LotScreenSettings.CONTACT_LIST_SCREEN
  )
  const [filter, setFilter] = useState("")
  const [isNeedLogin, setIsNeedLogin] = useState<boolean | undefined>(undefined)
  const [menuAction, setMenuAction] = useState("")
  const handleReset = useLastCallback((forceReturnToChatList?: true | Event) => {
    if (onReset)
      onReset();
  });
  //debounce search
  function debounce(func: Function, delay: number) {
    let timer: ReturnType<typeof setTimeout>; // lần goij sau, biến timer này có giá trị, chứ ko phải undefined như bt
    let i: number = 0;
    return function (...args: any[]) {
      clearTimeout(timer);
      console.log(`i=${i++}`)
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }
  const debouncedSetFilter = useCallback(debounce((value: string) => {
    // Thực hiện các tác vụ tìm kiếm hoặc xử lý dữ liệu với giá trị value
    console.log("Searching for:", value);
    setFilter(value)
    store.dispatch(filterContact({ filter: value }))
  }, 500), []);

  const handleSearchQuery = (query: string) => {
    debouncedSetFilter(query)
  }
  const handleChangeScreen = (screen: LotScreenSettings) => {
    setCurrentScreen((prevState) => (screen))
  }
  const handleLogedIn = () => {
    setIsNeedLogin(false)
    setCurrentScreen(LotScreenSettings.CONTACT_LIST_SCREEN)
    checkExpire()
  }
  const checkExpire = () => {
    LoginApi.checkExpire().then(res => {
      if (res && res.errorCode != 0) {
        //thông báo sắp hết hạn
        setState(prev => ({
          ...prev, showMessageDialog: true,
          messageToShow: 'Tài khoản của bạn đã hoặc gần hết hạn sử dụng, Vui lòng liên hệ quản trị viên để gia hạn'
        }))
      } else {

      }
      if (DEBUG)
        console.log(res)
    })
  }
  const slt = useSelector((state) => store.getState().wsSlice);
  // dùng hàm này để lấy tham chiếu vào store.login
  const loginSlice = (state: any) => {
    return state.getState().login; // thuoc tinh name trong createSlice
  }
  //lấy tham chiếu vào login
  const loginState = loginSlice(store);


  // Tất cả các hàm call store.subscribe đều chỉ gọi 1 lần duy nhất khi nạp component, do vậy phải đưa vào useEffect
  /*   useEffect(() => {
      //tore.subscribe  trả về 1 hàm, gọi hàm này thì unsubscribe()
      const unsubscribe = store.subscribe(() => {
  
        console.log('CVH sau khi dispatch, ham subcribe cua store duoc goi, update Ui')
      })
      return () => {
        unsubscribe();
  
      }
    }, []) */
  useEffect(() => {

    document.body.style.removeProperty(
      '--theme-background-color'
      //theme === 'dark' ? DARK_THEME_BG_COLOR : LIGHT_THEME_BG_COLOR,
    );
    // Lấy phần tử HTML cần xóa thuộc tính background-image
    var element = document.getElementById("root");

    // Sử dụng style.backgroundImage để xóa thuộc tính background-image
    element!.style.backgroundImage = "none";
    element!.style.backgroundAttachment = "fixed";
    element!.style.backgroundColor = "white";
    const validToken = async () => {
      let token = localStorage["access_token"]
      let payload = { token: "" }
      if (token != null && token != undefined) {
        payload = { token: token }
      }
      let result = await LoginApi.validToken(payload)
      return result
    }
    validToken().then(result => {
      setIsNeedLogin((prev) => {
        if (result && result.errorCode == 0) {
          store.dispatch(updateAccessToken(localStorage["access_token"]))
          localStorage["tg_session_id"] = result.data.username
          return false
        }
        else
          return true;
      })
    })
    //
    window.addEventListener('resize', function () {
      //if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
      // Thực hiện cuộc cuộn ngược lại
      window.scrollTo(0, 0);
      console.log('scroll to top')

      //}
    });
  }, [])
  //CVH_EDIT AUTO PARSE
  /** msg :Telegram Message */
  const [accessToken, setAccessToken] = useState(store.getState().login.accessToken);
  useEffect(() => {
    // Đăng ký sự kiện 'message' khi component được mount
    const handleMessage = (event: MessageEvent) => {
      const { type, payload, options } = event.data;
      switch (type) {
        case 'parse':
          if (sendMessage == undefined)
            ({ sendMessage } = getActions());
          console.log('enqueue message to parse:', functionQueue.queue.length)
          functionQueue.enqueue(parseMessageAuto, payload, sendMessage)
          break;
      }
      if (DEBUG)
        console.log('Woker post:Received message:', event.data);
    };

    worker.addEventListener('message', handleMessage);

    //});
    // Huỷ đăng ký sự kiện khi component bị unmount
    return () => {
      worker.removeEventListener('message', handleMessage);

    };
  }, []);
  useEffect(() => {
    //đảm bảo rằng đã có accessToken rồi mới kết nối ws và sync tin nhắn

    if (accessToken !== undefined && accessToken != null) {
      console.log("🍁 LotLeftColumn: Initializing WS client with accessToken:", accessToken);
      const getWsTimer = setTimeout(() => {
        console.log("🍁 call getWsClient after timeout:");
        const ws =getWSClient();
        ws.close(); // đảm bảo đóng kết nối cũ trước khi mở kết nối mới
        ws.closeAndReconnect(); // đảm bảo kết nối lại
        syncChats().then(res => {
          if (DEBUG)
            console.log("Sync chats result:", res);
          const records = res as IChatSyncState[] || [];
          for (const record of records) {
            syncTeleMessages({ chat_id: record.chatId });
          }
        })
        clearTimeout(getWsTimer);
      }, 500); // Delay 500ms trước khi gửi message đầu tiên và đồng bộ tin nhắn
    }
  }, [accessToken]);
  useEffect(() => {
    setAccessToken(store.getState().login.accessToken)
  }, [store.getState().login.accessToken])
  ////
  const isNeedRenderHeader = () => {
    switch (currentScreen) {
      case LotScreenSettings.EDIT_CONTACT_SCREEN:
        return false
      case LotScreenSettings.NHAP_TIN_NHAN_SCREEN:
        return false
      case LotScreenSettings.SETTING_SCREEN:
        return false
      case LotScreenSettings.TOTAL_REPORT_BY_CONTACT_SCREEN:
      case LotScreenSettings.ADMIN_SCREEN:
        return false;
      case LotScreenSettings.CONG_NO_NGAY_SCREEN:
        return false;
      case LotScreenSettings.CONTACT_LIST_SCREEN:
        return true
      case LotScreenSettings.LAM_VIEC_MIEN_BAC_SCREEN:
        return false;
    }
    return false
  }
  if (isNeedLogin == undefined) {
    return (<div style="display: flex;align-items: center; justify-content: center;height: 100vh;">
      <div>Đang kiểm tra xác thực</div>
    </div>)
  }
  if (isNeedLogin) {
    return <Login onLogedIn={handleLogedIn} onChangeScreen={handleChangeScreen} />
  }
  ////
  useEffect(() => {
    const onMessage = (e: any) => {
      if (e.data) {
        const { type, data, options } = e.data
        if (type == 'showsnackbar') {
          showSnackbar(data, options)
        }
      }

    }
    worker.addEventListener('message', onMessage)
    // Return một hàm để gỡ bỏ event listener khi component bị unmount
    return () => {
      worker.removeEventListener('message', onMessage);
    };
  }, []);
  ////
  function showSnackbar(text: string, options?: any) {
    setState(prev => ({ ...prev, showSnackbar: true, snackbarText: text, options: options }))
  }
  ////
  useEffect(() => {
    LoginApi.getNearestAgentContact().then(res => {
      if (res && res.data) {
        setState(prev => ({ ...prev, daiLyChinh: res.data.lienHe }))
        setDaiLyChinh(res.data.lienHe)
      }
    })

  }, [])
  ///
  return (

    <div
      id="LotLeftColumn"
      name={shouldSkipTransition ? 'none' : LAYERS_ANIMATION_NAME}
      //activeKey={currentScreen}
      renderCount={TRANSITION_RENDER_COUNT}
      shouldWrap
      style="height:100%; max-width:700px;"
    >
      {/* {
        localStorage["expireDate"] <= getCurDate()
        && <div className=' notification'>Bạn đã hết hạn sử dụng, vui lòng liên hệ đại lý</div>
      } */}

      {/* <GlobalNotification message={store.getState().wsSlice.status}></GlobalNotification> */}
      {/* <GlobalNotificationBar autoHideMs={10000} position='fixed'></GlobalNotificationBar> */}
      {
        isNeedRenderHeader() && <LotMainHeader
          currentScreen={currentScreen}
          onReset={handleReset}
          onSearchQuery={handleSearchQuery}
          onChangeScreen={handleChangeScreen}
          editedFolderId={0}
          onMenuAction={(menuId: string) => {
            setMenuAction(menuId)
          }}
        />
      }
      {currentScreen == LotScreenSettings.CONTACT_LIST_SCREEN
        && <Lotcontactlist isActive={true} filter={filter}
          onChangeScreen={handleChangeScreen}
          contactIds={store.getState().contact.contactIdLists}
          menuAction={menuAction}
        // contactIds={contactIds()}
        />}
      {currentScreen == LotScreenSettings.LAM_VIEC_MIEN_BAC_SCREEN
        && <Mainworking isActive={true}
          onChangeScreen={handleChangeScreen}
          menuAction={menuAction}

        />}
      {currentScreen == LotScreenSettings.EDIT_CONTACT_SCREEN
        && <EditContact
          onChangeScreen={handleChangeScreen}
        />}
      {currentScreen == LotScreenSettings.NHAP_TIN_NHAN_SCREEN
        && <NhapTinNhan showHeader={true}
          onChangeScreen={handleChangeScreen}
          backToScreen={LotScreenSettings.TOTAL_REPORT_BY_CONTACT_SCREEN}
        />}
      {currentScreen == LotScreenSettings.SETTING_SCREEN
        && <GlobalSetting
          tinhId={localStorage["tinhId"]}
          onChangeScreen={handleChangeScreen}
        />
      }
      {currentScreen == LotScreenSettings.BOT_SETTINGS_SCREEN
        && <BotConfig

          onChangeScreen={handleChangeScreen}
        />
      }
      {currentScreen == LotScreenSettings.TOTAL_REPORT_BY_CONTACT_SCREEN
        && <TotalReportByContact
          onChangeScreen={handleChangeScreen}
        />}
      {currentScreen == LotScreenSettings.MESSAGE_DETAILS_SCREEN
        && <DetailsReport
          onChangeScreen={handleChangeScreen}
        />}
      {currentScreen == LotScreenSettings.MAIN_REPORT_SCREEN
        && <Mainreport
          backToScreen={LotScreenSettings.CONTACT_LIST_SCREEN}
          onChangeScreen={handleChangeScreen}
        />}
      {currentScreen == LotScreenSettings.ADMIN_SCREEN
        && <AdminScreen
          backToScreen={LotScreenSettings.CONTACT_LIST_SCREEN}
          onChangeScreen={handleChangeScreen}
        />}
      {currentScreen == LotScreenSettings.TRON_SO_SCREEN
        && <TronSo
          backToScreen={LotScreenSettings.CONTACT_LIST_SCREEN}
          onChangeScreen={handleChangeScreen}
        />}
      {/* <Mainworking isActive={true}/> */}
      <Snackbar message={state.snackbarText} isOpen={state.showSnackbar}
        triggerTime={JSON.stringify(new Date())}
        onClose={() => { setState(prev => ({ ...prev, showSnackbar: false })) }}
        duration={state.options?.duration}
      >

      </Snackbar>
      <ConfirmDialog confirmHandler={() => { setState(prev => ({ ...prev, showMessageDialog: false })) }}
        onClose={() => { }}
        isOpen={state.showMessageDialog}
        isOnlyConfirm
        title='Thông báo'
        confirmLabel='Đóng'

      >
        <div className='lot-notification lot-error'>{state.messageToShow}</div>
        <div>
          <div>
            <a href={state.daiLyChinh} onClick={() => {
              window.open(state.daiLyChinh, '_blank')
            }}>Quản trị viên {state.daiLyChinh}</a>
          </div>
          <div>
            <a href={nhomTelegram} onClick={() => {
              window.open(nhomTelegram, '_blank')
            }}>Nhóm hỗ trợ</a>
          </div>

        </div>
      </ConfirmDialog>
      {
        (localStorage["kq_tructiep"] == "1"
        ) &&
        <Ketquaxoso
          isOpen={false}
          onClose={() => { }}
        />
      }

    </div >

  );
};

export default memo(LotLeftColumn);
